import {HandleShaderCreatorPrinter} from "./OwayoShaderSourceForSelObCreator";
import {SingleShaderCreator} from "./SingleShaderCreator";
import {PartSelectableObject} from "../partSelOb";
import {curry} from "@k/global/functionalTools";
import {PartPattern} from "../pattern/partPattern";
import {GreyOutState, OwayoKonfiPart} from "../owayoPartWithSelObs";
import {UtilityPlane} from "../utilityPlane";
import {CONSTANTS} from "../meta_data";
import {lightFragmentOwayo} from "./shader_light_fragment";
import {THREE} from "../resource/three.js"
import {OwayoPartBaseClass} from "../../../vorschauviewer/src/js/owayoPartBaseClass";
import {addMaterialUniformsIfNeeded} from "./uniforms";
import {PartForMaterial} from "../owayoJSViewerWithSelObs";

export const owayoVertexShader = [

    'varying vec2 vUv;',
    'varying vec2 vOriginalUv;',

    'varying vec3 vViewPosition;',
    'varying vec3 vNormal;',

    'uniform vec4 offsetRepeat;',

    'void main() { ',
    // In der denke von ThreeJS gibt es bisher nur eine Variable vUv für alle
    // Maps zusammen. Da es bisher nur ein Offeset und Repeat für alle zusammen gibt.
    // Wenn wir also den Quellcode von ThreeJS übernehmen wollen, so müssen wir nun
    // vUv auf die BumpMap einstellen
    // Wir übergeben für uns selber noch die OriginalUV
    '  vUv = uv * offsetRepeat.zw + offsetRepeat.xy;',
    '  vOriginalUv = uv; ',
    THREE.ShaderChunk.begin_vertex,

    THREE.ShaderChunk.beginnormal_vertex,

    THREE.ShaderChunk.project_vertex,

    '  vViewPosition = mvPosition.xyz;',
    THREE.ShaderChunk.defaultnormal_vertex,
    '  vNormal = transformedNormal;',
    '}'
];

export const isOnStraightLine =  [

    'float isOnStraightLine(vec2 toTest, vec3 testAgainst, float dist) {',
    '   return step(abs(toTest.x - testAgainst.x), dist) * step(testAgainst.y - dist, toTest.y) * step (toTest.y, testAgainst.z +dist);',
    '}'

];
const owayoVertexShader_Minimum = [

    'varying vec2 vUv;',

    'void main() { ',
    '  vUv = uv; ',
    THREE.ShaderChunk.begin_vertex,
    THREE.ShaderChunk.beginnormal_vertex,

    THREE.ShaderChunk.project_vertex,
    '}'
];

// CONSTANTS.owayoShaderIsInDistance = [
//
//     'float distSquared(vec2 a, vec2 b) {',
//     '   return( ((a.x - b.x) * (a.x - b.x))  + (a.y - b.y)*(a.y - b.y) );',
//     '}  ',
//
//
//     'float isInDistance(vec2 p, vec2 v, vec2 w, float dist) { ',
//
//     '  if ( step( min(v.x, w.x) , p.x +  dist )  * step( min(v.y, w.y) , p.y  +  dist ) * step( p.x , max(v.x, w.x)  +  dist ) * step( p.y , max(v.x, w.y)  +  dist )   == 0.0 ) { return 0.0; }   ',
//
//     '   float l2; ',
//     '   float t; ',
//     '   float e = 1.0e-10; ',
//     '   vec2 diff = w-v;',
//     '   l2 = dot(diff, diff) + e ;',
//     '   t = clamp(((p.x - v.x) * diff.x + (p.y - v.y) * diff.y) / l2, 0.0, 1.0);  ',
//     '   return step(distance(p, v + t*diff), dist);',
//     '}    '
// ];

// CONSTANTS.owayoShaderDistancePointToLine = [
//
//     'float distSquared(vec2 a, vec2 b) {',
//     '	return( ((a.x - b.x) * (a.x - b.x))  + (a.y - b.y)*(a.y - b.y) );',
//     '}  ',
//
//
//     'float distToSegmentSquared(vec2 p, vec2 v, vec2 w) { ',
//     '  	float l2; ',
//     '	float t; ',
//     '	float angle; ',
//
//     '	l2 = ((v.x - w.x) * (v.x - w.x)  + (v.y - w.y)*(v.y - w.y) ) ;',
//
//     //wenn v===w
//     '	if (l2 == 0.0) {    ',
//     '		return ((p.x - v.x) * (p.x - v.x))  + (p.y - v.y)*(p.y - v.y) ;',
//     '	}  ',
//
//     // Ansonsten fang an zu berechnen ob wir neben der Strecke liegen
//     '	t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;  ',
//     '	if (t < 0.0) {  ',
//     '		return ((p.x - v.x) * (p.x - v.x))  + (p.y - v.y)*(p.y - v.y) ;',
//     '	}  ',
//     '	if (t > 1.0) {  ',
//     '		return ((p.x - w.x) * (p.x - w.x))  + (p.y - w.y)*(p.y - w.y) ;',
//     '	} ',
//     '		return ( ( p.x - (v.x + t * (w.x - v.x) )  ) * ( p.x - (v.x + t * (w.x - v.x) )  ) )  + (p.y - ( v.y + t * (w.y - v.y) ) )*(p.y - (v.y + t * (w.y - v.y) ) ) ;',
//     '}	 '
//
// ];

export const SHADER_CHUNKS = {
    blendPixels : [
        '  vec4 ColorA;',
        '  vec4 ColorB;',
        '  vec4 ColorC;',
        '  vec4 ColorD;',
        '  float A; ',
        '  float B; ',
        '  float C; ',
        '  float D; ',
        // Wir haben nun eine Pixelcoordinate von z.b.: x:1,23 y:2,78
        // das bedeutet das wir eigentlich zwischen den Pixeln liegen.
        // Und wir deshalb eigentlich eine Farbmischung aus 4 Pixeln erzeigen wollen, je nach dem wie
        // nahe er an welchem Pixel ist.
        //
        //  -------------
        //  |  B  |  C  |
        //  -------------
        //  |  A  |  D  |
        //  -------------
        //
        // Pixel A ist dabei der Pixel x:1 y:2  und C der Pixel x:2 y:3

        //
        //  Die Funktoin texelFetch existiert erst ab Opengl ES 3.0 und wir haben nur 1.0
        '  PixelPositioninOriginalInt.x = int(PixelPositioninOriginal.x);',
        '  PixelPositioninOriginalInt.y = int(PixelPositioninOriginal.y);',

        '  PixelPositioninOriginalWheight.x = PixelPositioninOriginal.x - float(PixelPositioninOriginalInt.x);',
        '  PixelPositioninOriginalWheight.y = PixelPositioninOriginal.y - float(PixelPositioninOriginalInt.y);',

        '  vUvPixel.x =  float(PixelPositioninOriginalInt.x) * TexturePixelToUvMulti.x;  ',
        '  vUvPixel.y =  float(PixelPositioninOriginalInt.y) * TexturePixelToUvMulti.y;  ',
        '  ColorA = texture2D(ColorTextures[0], vUvPixel);',

        '  vUvPixel.y =  float(PixelPositioninOriginalInt.y+1) * TexturePixelToUvMulti.y;  ',
        '  ColorB = texture2D(ColorTextures[0], vUvPixel);',

        '  vUvPixel.x =  float(PixelPositioninOriginalInt.x+1) * TexturePixelToUvMulti.x;  ',
        '  ColorC = texture2D(ColorTextures[0], vUvPixel);',

        '  vUvPixel.y =  float(PixelPositioninOriginalInt.y) * TexturePixelToUvMulti.y;  ',
        '  ColorD = texture2D(ColorTextures[0], vUvPixel);',

        // Wenn ColorA > 200 ist so werden wir später nach den farben abbrechen, da wir dann keine Logogs oder
        // Texte über diesen Part des Trikots gelegt werden dürfen.
        ' A = ColorA.r;',
        ' B = ColorB.r;',
        ' C = ColorC.r;',
        ' D = ColorD.r;',

        '  ColorA = texture2D(ColorTextures[1], vec2(A,0.5));',
        '  ColorB = texture2D(ColorTextures[1], vec2(B,0.5));',
        '  ColorC = texture2D(ColorTextures[1], vec2(C,0.5));',
        '  ColorD = texture2D(ColorTextures[1], vec2(D,0.5));',


        // Wir verschmelzen als erstes in der Y richtung die beiden Farben also A und B   sowie D und C
        '   ColorA = vec4( mix(ColorA.rgb, ColorB.rgb, PixelPositioninOriginalWheight.y), 1);',
        '   ColorD = vec4( mix(ColorD.rgb, ColorC.rgb, PixelPositioninOriginalWheight.y), 1);',
        // Und nun kommt die endgültige farbe heraus, wenn wir nun noch in der X-Richtung das ganze verschmelzen
        '   ColorResult = vec4( mix(ColorA.rgb, ColorD.rgb, PixelPositioninOriginalWheight.x), 1);',
        '   A *= 255.0;'
    ],
    dontBlendPixels: [
        '  vec4 ColorA;',
        '  ColorResult = vec4(1.0,0.0,1.0,1.0); ',
        '  float A; ',
        '  vec2 vOriginalUVcorrected;',
        '  ColorA = texture2D(ColorTextures[0], vOriginalUv);',
        '  A = ColorA.r; ',
        '  ColorResult = texture2D(ColorTextures[1], vec2(A,0.5));',
        '  A *= 255.0; '
    ],
    brightenBlack : [
        /*
         *  Wir haben uns überlegt auch weiss leicht abzudunkeln, damit man es vor dem Hintergrund noch sehen kann.
         *  Bisher kann man es jedoch auch ohne abdunkeln sehr gut erkennen. Und deswegen wird es nicht abgedunkelt, da
         *  dies einen schlechten Eindruck macht.
         */
        // Schwarz wird leicht angegraut damit schatten noch sichtbar sind.
        // Und damit auch die Falten im Stoff noch zu erkennen sind.
        ' if (ColorResult.r < 0.12 && ColorResult.g < 0.12 && ColorResult.b < 0.12)',
        ' {',
        '     ColorResult.rgb = vec3(0.12);',
        ' }'
    ]
};

export class HandleShaderCreator {

    public static createHandleShader(part: OwayoKonfiPart, overrideShader:string|null = null) {
        const handleTranslation:THREE.Vector[] = [];
        const handleIconIndex:number[] = [];
        const paintHandles:string[]= [];

        part.handles.forEach(function(handle, index) {
            handleTranslation.push(new THREE.Vector2(handle.translation.x, handle.translation.y));
            handleIconIndex.push(handle.iconIndizes[handle.status]);
            paintHandles.push(HandleShaderCreatorPrinter.getHandleShaderSource(index));
        });
        paintHandles.push(HandleShaderCreatorPrinter.returnIfHandleHit());

        const ShaderUniforms = HandleShaderCreator.getHandleShaderUniforms(
            part.handleAndGuideLayer,
            part.parent.handleTexture,
            handleIconIndex,
            handleTranslation,
            part.parent.utilityPainter.fadingAlpha
        );

        const FragmentShader = HandleShaderCreator.getHandleFragmentShader(part, paintHandles, overrideShader);

        return new THREE.ShaderMaterial({
            vertexShader: owayoVertexShader_Minimum.join('\n'),
            uniforms: ShaderUniforms,
            fragmentShader: FragmentShader.join('\n'),
            transparent: true,
            lights: false,
            side: THREE.FrontSide
        });
    }

    private static getHandleShaderUniforms(layer:UtilityPlane, handleTexture, handleIconIndex, handleTranslation, fadingAlpha) {
        return {
            "handleTexture": {type: "tv", value: [handleTexture]},
            "handleIconIndex": {type: "fv1", value: handleIconIndex},
            "handleTranslation": {type: "v2v", value: handleTranslation},
            "textureAlpha": {type: "f", value: fadingAlpha},
            "anzMatrices": {type: "i", value: layer.anzMatrices},
            "matrices": {type: "m3v", value: layer.matrices},
            "anzRectangles": {type: "i", value: layer.anzRectangles},
            "rectangles": {type: "v4v", value: layer.rectangles},
            "rectangleColors": {type: "fv1", value: layer.rectangleColors},
            "anzVerticalLines": {type: "i", value: layer.anzVerticalLines},
            "anzHorizontalLines": {type: "i", value: layer.anzHorizontalLines},
            "horizontalLines": {type: "v3v", value: layer.horizontalLines},
            "verticalLines": {type: "v3v", value: layer.verticalLines}
        };
    }

    private static getHandleFragmentShader(part:OwayoKonfiPart, paintHandles, overrideShader:string|null = null) {
        if (overrideShader !== null) {
            return [overrideShader];
        } else {
            const image = (part.parent.handleTexture as THREE.Texture).image;
            return [

                '#define AnzHandles ' + part.handles.length,
                'varying vec2 vUv;',

                'uniform sampler2D handleTexture[1];',
                'uniform float     textureAlpha;',

                'uniform int anzVerticalLines;',
                'uniform int anzHorizontalLines;',
                'uniform int anzRectangles;',
                'uniform int anzMatrices;',
                'uniform mat3 matrices[8];',
                'uniform vec3 horizontalLines[5];',
                'uniform vec3 verticalLines[5];',
                'uniform vec4 rectangles[8];',
                'uniform float rectangleColors[8];',
                'const vec4 standardHelperColor = vec4(0.8, 0.8, 0.8, 1.0);',
                'const vec4 warningHelperColor = vec4(1.0, 0.2, 0.2, 1.0);',
                'const float helperLinesThickness = ' + CONSTANTS.HELPER_LINEWIDTH + '.0;',
                'const vec2  TextureGesamtGroesse = vec2(' + part.textureSize.x + ',' + part.textureSize.y + ');',
                'const vec2  handleTextureSize    = vec2(' + image.width + ',' + image.height + ');   ',
                'const vec2  handleIconSize       = vec2(' + CONSTANTS.HANDLER_WIDTH + ',' + CONSTANTS.HANDLER_HEIGHT + ');   ',
                'const float inversePartStauchungsfaktor = ' + (1 / part.partStauchungsFaktor).toFixed(5) + ';',
                (part.handles.length > 0 ?
                        [
                            '  uniform vec2      handleTranslation[AnzHandles];',
                            '  uniform float     handleIconIndex[AnzHandles];'
                        ].join("\n")
                        : ''
                ),

//      CONSTANTS.owayoShaderIsInDistance.join("\n") ,
                isOnStraightLine.join("\n"),

                'void main(void) {',
                '  vec2 mProd;',
                '  vec2 pixelCoord = TextureGesamtGroesse * vUv;',
                '  vec2 pixelPosInHandle;',
                '  float helperAlpha = 0.0;',
                '  bool  hitHandler = false;',
                '  float showStandardColor = 1.0;',
                '  float hasHitRectangle = 0.0;',

                paintHandles.join("\n"),
                //////////////////////////////////////////////////////////////////////////
                //TODO würde man immer die nicht mehr vorhandenen Linien auf 0 setzen, könnte man die folgenden Abfragen in 2 for Schleifen zusammenfassen...
                // ich glaub aber, dass es langsamer sein könnte, die uniforms alle auf 0 zu setzen... müsste man ausprobieren...
                // (VIEWERFEATURE.BREAK_HANDLESHADER !== false ? [
                'for (int j = 0; j < 5; j++) {',
                '    if (j >= anzHorizontalLines) {break;}',
                '    helperAlpha += isOnStraightLine(pixelCoord.yx, horizontalLines[j], helperLinesThickness);',
                '}',

                'for (int j = 0; j < 5; j++) {',
                '    if (j >= anzVerticalLines) {break;}',
                '    helperAlpha += isOnStraightLine(pixelCoord, verticalLines[j], helperLinesThickness);',
                '}',
                'for (int j = 0; j < 8; j ++) {',
                '    if (anzRectangles <= j) {break;}',
                '    hasHitRectangle = ',
                '    isOnStraightLine(pixelCoord.yx, rectangles[j].yxz, helperLinesThickness)',
                '                + isOnStraightLine(pixelCoord.yx, rectangles[j].wxz, helperLinesThickness)',
                '                + isOnStraightLine(pixelCoord, rectangles[j].xwy, helperLinesThickness)',
                '                + isOnStraightLine(pixelCoord, rectangles[j].zwy, helperLinesThickness);',
                '    helperAlpha += hasHitRectangle;',
                '    showStandardColor -= (hasHitRectangle * rectangleColors[j]);',
                '}',
                'for(int j = 0; j < 8; j++ ) {',
                '    if (j >= anzMatrices){break;}',
                '    mProd = (matrices[j] * vec3(pixelCoord, 1.0)).xy;',
                '    helperAlpha += step(abs(mProd.x), 1.0) * step(abs(mProd.y), 1.0);', //1 <==> -1 < x < 1 und -1 < y < 1, sonst 0
                '}',
                'gl_FragColor = standardHelperColor * vec4( 1.0, showStandardColor, showStandardColor, textureAlpha * helperAlpha);',//sshowStandardColor, showStandardColor, textureAlpha * helperAlpha);',
                '}' //Ende main()
            ];
        }
    }
}

export const ShaderCreator ={
    ANZCOLORTEXTURES : 2,
    owayoLogosOnTop:()=>{
        console.log("function ShaderCreator.owayoLogosOnTop is still on default value 'true!'");
        return true;
    },
    setOwayoLogosOnTopGetter:(getter:(()=>boolean))=> ShaderCreator.owayoLogosOnTop = getter,
    alleSelObsPassenInShader : (maxTextures, nonSelObTextures, anzSelObs)=>maxTextures >= nonSelObTextures + anzSelObs,

    getShadersForPartOhnePartImage(part: OwayoKonfiPart, patterns:PartPattern[]) {
        ShaderCreator.disposeShaders(part);
        const maxTextures = part.parent.webGLBrowserLimits.maxTextures;
        const nonSelObTextures = ShaderCreator.ANZCOLORTEXTURES + ShaderCreator.getAnzahlStoffTexturen(part);
        const patternsAndSelObs = (patterns as PartSelectableObject[]).concat(part.selectableObjects);

        if (ShaderCreator.alleSelObsPassenInShader(maxTextures, nonSelObTextures, patternsAndSelObs.length)) {
            return [SingleShaderCreator.createSingleShader(part, true, patternsAndSelObs, patternsAndSelObs.length)];
        } else {
            return ShaderCreator.getMultipleShaders(part, patternsAndSelObs, maxTextures);
        }

    },

    createShadersWithoutColors(part:OwayoKonfiPart, patternsAndSelObs:PartSelectableObject[], selObsPerShader:number) {
        const shaders:THREE.ShaderMaterial[] = [];
        while (patternsAndSelObs.length > 0) {
            const anzSelObsToDisplay = Math.min(patternsAndSelObs.length, selObsPerShader);
            shaders.push(SingleShaderCreator.createSingleShader(part, false, patternsAndSelObs, anzSelObsToDisplay));
            patternsAndSelObs.splice(0, anzSelObsToDisplay);
        }
        return shaders;
    },

    getMultipleShaders(part:OwayoKonfiPart, patternsAndSelObs:PartSelectableObject[], maxTextures) {

        const anzahlStoffTexturen = ShaderCreator.getAnzahlStoffTexturen(part);
        const maxSelObsPerShader_Without_Colors = maxTextures - anzahlStoffTexturen;
        const maxSelObsPerShader_With_Colors =  maxSelObsPerShader_Without_Colors - ShaderCreator.ANZCOLORTEXTURES;

        const firstShader = SingleShaderCreator.createSingleShader(part, true, patternsAndSelObs, maxSelObsPerShader_With_Colors);
        patternsAndSelObs.splice(0, maxSelObsPerShader_With_Colors);
        return [firstShader].concat(ShaderCreator.createShadersWithoutColors(part, patternsAndSelObs, maxSelObsPerShader_Without_Colors));
    },

    /**
     * Erstellt alle Shader für den part. Im Moment nur einen
     */
    createShaders : function (part: OwayoKonfiPart|OwayoPartBaseClass, patterns:PartPattern[]) {
        if (part.hasZentralesAbgelegtesNichtEinfaerbbaresPartImage) {
            part.shaders.push(ShaderForPartImageCreator.createShader(part));
        } else {
            part.shaders = ShaderCreator.getShadersForPartOhnePartImage(part as OwayoKonfiPart, patterns);
        }
        (part.mesh as THREE.Mesh).material.dispose();
        (part.mesh as THREE.Mesh).material = part.shaders[0];
        part.parent.render();
    },


    disposeShaders(part: OwayoKonfiPart|OwayoPartBaseClass) {
        part.shaders.forEach(function(s) {
            s.dispose();
        });
    },

    getAnzahlStoffTexturen(part: OwayoKonfiPart|OwayoPartBaseClass) {
        return [part.alphaMap, part.bumpMap, part.normalMap, part.specularMap, part.shadowMap, part.overlayMap].filter(m=>m).length
    },
    mapAndImagePresent : (part:OwayoKonfiPart, mapname)=>part[mapname] && part[mapname].image,



    addMaterialPreProcessorDirectivesIfNeeded : function (part: PartForMaterial) {
        const mapAndImagePresent = mapname=>part[mapname] && part[mapname].image;

        return [
            mapAndImagePresent("bumpMap") ? '#define USE_BUMPMAP' : '',
            mapAndImagePresent("normalMap") ? '#define USE_NORMALMAP' : '',
            mapAndImagePresent("alphaMap") ? '#define USE_ALPHAMAP' : '',
            mapAndImagePresent("specularMap") ? '#define USE_SPECULARMAP' : '',
            mapAndImagePresent("overlayMap") ? '#define USE_OVERLAYMAP' : ''
        ].join("\n");
    },

    addMaterialFragmentShaderParameterIfNeeded : function (part: PartForMaterial) {
        const mapAndImagePresent = curry(ShaderCreator.mapAndImagePresent, part);

        return [
            mapAndImagePresent("bumpMap") ? THREE.ShaderChunk.bumpmap_pars_fragment : '',
            mapAndImagePresent("normalMap") ? THREE.ShaderChunk.normalmap_pars_fragment : '',
            mapAndImagePresent("alphaMap") ? THREE.ShaderChunk.alphamap_pars_fragment : '',
            mapAndImagePresent("specularMap") ? THREE.ShaderChunk.specularmap_pars_fragment : '',
            mapAndImagePresent("shadowMap") ? 'uniform sampler2D shadowMap;' : ''
        ].join("\n");
    },

    addFragmentMaterialAndLighting : function (part: PartForMaterial) {
        return [
            'float shininess = ' + part.shininess.toFixed(4) + ';',
            'float specularMin = ' + part.specularMin.toFixed(4) + ';',
            'vec3 specular = vec3(' + part.specular.toFixed(4) + ');',

            (part.specularMap && (part.specularMap as THREE.Texture).image ? THREE.ShaderChunk.specularmap_fragment : 'float specularStrength = 1.0;'),
            (part.alphaMap && (part.alphaMap as THREE.Texture).image ? " ColorTmp = texture2D( alphaMap, vUv );  gl_FragColor.a *= (0.229*ColorTmp.r + 0.587*ColorTmp.g +  0.114*ColorTmp.b);" : ''),

            // ShadowMap
            // Versuch 1 : Mix die farbe mit Schwarz je nach dem was in der Shadowmap steht. Ergebnis: Der Schatten ist viel zu hell.
            // (this.shadowMap      && this.shadowMap.image      ? " ColorTmp = texture2D( shadowMap, vOriginalUv );  gl_FragColor.rgb = mix( gl_FragColor.rgb, vec3(0.0) , (1.0-(0.229*ColorTmp.r + 0.587*ColorTmp.g +  0.114*ColorTmp.b)) );" :''),
            // Versuch 2 : Ziehe dort wo schatten ist einfach die RGB Werte von der farbe ab. Ergebnis: Gut dsa nehmen wir jetzt erstmal (Beni 14.10.2015)
            (part.shadowMap && (part.shadowMap as THREE.Texture).image ? " ColorTmp = texture2D( shadowMap, vOriginalUv );  gl_FragColor.rgb = gl_FragColor.rgb - (1.0 - ColorTmp.rgb);" : ''),

            // Beleuchtung hinzufügen.
            lightFragmentOwayo.join("\n")
        ].join("\n");
    }
}



export class ShaderForPartImageCreator {
    public static createShader = function (part: PartForMaterial) {
        return new THREE.ShaderMaterial({
            vertexShader: owayoVertexShader.join('\n'),
            uniforms: ShaderForPartImageCreator.getShaderUniforms(part),
            fragmentShader: ShaderForPartImageCreator.getFragmentShader(part).join('\n'),
            transparent: typeof (part.alphaMap) !== "undefined" && (part.alphaMap !== null) && (part.alphaMap as THREE.Texture).image,
            lights: true,
            shading: THREE.SmoothShading,
            side: THREE.DoubleSide
        });
    };

    private static getFragmentShader(part:PartForMaterial) {
        return [

            '//SIMPLESHADER',
            // "#extension GL_OES_standard_derivatives : enable",
            'varying vec2 vUv;',
            'varying vec2 vOriginalUv;',
            '  vec4 ColorTmp;',

            'uniform vec3 diffuse;',
            'uniform vec3 ambient;',
            'uniform vec3 emissive;',
            'uniform vec4 offsetRepeat;',
            'uniform int isGreyedOut;',
            'uniform int isGreyedOutExceptDruckbereich;',
            'uniform sampler2D map;',
            THREE.ShaderChunk.common,
            ShaderCreator.addMaterialPreProcessorDirectivesIfNeeded(part),
            ShaderCreator.addMaterialFragmentShaderParameterIfNeeded(part),

            THREE.ShaderChunk.lights_phong_pars_fragment,

            'void main(void) {',
            '  vec4 ColorResult;',
            '  ColorResult = texture2D(map, vOriginalUv);',

            //Innenseite mit weiß abmischen.
            SHADER_CHUNKS.brightenBlack.join("\n"),
            ' gl_FragColor = vec4(mix(ColorResult.xyz,vec3(1,1,1),0.6*(1.0-float(gl_FrontFacing))),ColorResult.a ); ',
            ShaderCreator.addFragmentMaterialAndLighting(part),
            '}'
        ];
    }



    private static getShaderUniforms(part:PartForMaterial) {
        const ShaderUniforms = THREE.UniformsUtils.merge([
            THREE.UniformsLib.lights,
            {
                "diffuse": {type: "c", value: new THREE.Color(0xeeeeee)},
                "ambient": {type: "c", value: new THREE.Color(0xffffff)},
                "emissive": {type: "c", value: new THREE.Color(0x000000)},
                "offsetRepeat": {type: "v4", value: part.offsetRepeat},
                "isGreyedOut": {type: "i", value: (part.isGreyedOut === GreyOutState.GREYED_OUT ? 1 : 0)},
                "isGreyedOutExceptDruckbereich" : {type:"i", value:(part.isGreyedOut === GreyOutState.OUT_OF_DRUCKBEREICH_GREYED_OUT ? 1 : 0)},
                "map": {type: "tv", value: [part.map]}
            }
        ]);

        return addMaterialUniformsIfNeeded(part, ShaderUniforms);
    }
}

export function initShaderFunctionsInDebugMenu() {


}
